/* eslint-disable no-unused-vars */
import { styled } from "@mui/material";
import { TreeView, TreeItem } from "@mui/x-tree-view";

// Customized TreeItem
export const CustomizedTreeItem = styled(TreeItem)(({ theme, level }) => ({
	"& .MuiTreeItem-content.Mui-expanded": {
		backgroundColor: "transparent !important"
	},
	"& .MuiTreeItem-iconContainer": {
		display: "none !important"
	},
	"& .MuiTreeItem-content": {
		padding: "0px !important",
		marginLeft: "0px !important", // removes default margin from all tree items
		"&:hover": {
			backgroundColor: "transparent !important"
		}
	},
	"& .MuiTreeItem-content.Mui-selected": {
		width: "265px !important",
		height: "32px !important",
		backgroundColor: "transparent !important"
	},
	"& .MuiTreeItem-label": {
		padding: "0px !important",
		height: "32px !important",
		width: "265px !important"
	},
	"& .MuiTreeItem-group": {
		marginLeft: "0px !important" // removes default margin from all tree items
	},
	"&.MuiTreeItem-root": {
		display: "flex",
		flexDirection: "column",
		flexGrow: 1
	}
}));

// Customized TreeView
export const CustomizedTreeView = styled(TreeView)(({ theme }) => ({
	width: "100%"
}));
